import { Link } from "react-router-dom";

const LOGO_URL = "https://static.readdy.ai/image/7e5541a56ec34f9c335c4f691557a0ff/511904ad93867d769e16f6d50376127a.png";

export default function Footer() {
  return (
    <footer className="bg-stone-50 text-stone-700">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="w-36 h-12 flex items-center justify-start mb-4">
              <img src={LOGO_URL} alt="ClassLive留学アイルランド" className="h-full w-auto object-contain" />
            </div>
            <p className="text-stone-500 text-sm leading-relaxed">
              アイルランド留学のことなら<br />ClassLive留学にお任せください。<br />語学留学から高校留学まで、<br />あなたの夢をサポートします。
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-stone-700 mb-4 text-sm">サイトマップ</h4>
            <ul className="space-y-2">
              {[
                { label: "アイルランド留学の魅力", href: "/#charms" },
                { label: "アイルランド基本情報", href: "/#basicinfo" },
                { label: "高校留学", href: "/#highschool" },
                { label: "語学学校紹介", href: "/#schools" },
                { label: "よくある質問", href: "/#faq" },
                { label: "無料相談", href: "/#contact" },
              ].map((item) =>
                item.href.startsWith("/") && !item.href.startsWith("/#") ? (
                  <li key={item.label}>
                    <Link to={item.href} className="text-sm text-stone-500 hover:text-stone-800 transition-colors cursor-pointer">
                      {item.label}
                    </Link>
                  </li>
                ) : (
                  <li key={item.label}>
                    <a href={item.href} className="text-sm text-stone-500 hover:text-stone-800 transition-colors cursor-pointer">
                      {item.label}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Company Info */}
          <div>
            <h4 className="font-semibold text-stone-700 mb-4 text-sm">会社情報</h4>
            <p className="text-stone-700 text-sm font-semibold mb-2">株式会社ジージー</p>
            <ul className="space-y-1 text-xs text-stone-500 leading-relaxed mb-4">
              <li><span className="text-stone-600 font-medium">大阪本社：</span>大阪府大阪市中央区西心斎橋2丁目9-37 プライブ八幡ビル4F</li>
              <li><span className="text-stone-600 font-medium">東京支店：</span>東京都渋谷区渋谷 2-24-12 WeWork渋谷スクランブルスクエア 39階</li>
              <li><span className="text-stone-600 font-medium">福岡支店：</span>福岡県福岡市中央区天神1-14 Wework天神ブリッククロス 14F</li>
              <li><span className="text-stone-600 font-medium">セブ支社：</span>New Frontier, Mabolo, Cebu City, Cebu, Philippines 6000</li>
              <li><span className="text-stone-600 font-medium">バンコク支社：</span>T-One Building, 8 Sukhumvit, 40 Alley, 20Fl. Khet Khlong Toei, Phra Khanong, Bangkok.</li>
              <li><span className="text-stone-600 font-medium">マルタ支社：</span>203, Tower Road SLIEMA, Malta</li>
            </ul>
            <p className="text-xs text-stone-500 mb-4">
              ホームページ：{" "}
              <a href="https://ryugaku.class-live.com/" target="_blank" rel="noopener noreferrer" className="underline hover:text-stone-800 transition-colors cursor-pointer">
                https://ryugaku.class-live.com/
              </a>
            </p>
            <div className="flex gap-3">
              <a href="https://www.youtube.com/channel/UCBEJ-c5512fA_2RKjJF6qpA" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-200 hover:bg-emerald-100 text-stone-600 hover:text-emerald-700 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-sm" />
              </a>
              <a href="https://www.instagram.com/classlive_ryugaku/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-200 hover:bg-emerald-100 text-stone-600 hover:text-emerald-700 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm" />
              </a>
              <a href="https://www.tiktok.com/@classlive" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-200 hover:bg-emerald-100 text-stone-600 hover:text-emerald-700 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-sm" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-stone-200 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-stone-400">
          <p>&copy; 2025 ClassLive留学 All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
